import React, { useState } from 'react';
import * as yup from 'yup';
import { DistributionCard } from 'entities/distribution/ui/DistributionCard';
import { DistributionFormDataType, DistributionStateType } from 'entities/distribution/types';
import { useForm } from 'react-hook-form';
import { useCreateDistributionCardDefaultValues } from 'entities/distribution/lib/hooks/useCreateDistributionCardDefaultValues';
import { useAddDistributionMutation } from 'features/createDistributions/api/createDistributionApi';
import { useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { requiredErrorMessage } from 'shared/consts';
import { setDrawerOpen } from 'features/ui/model/uiSlice';

const validationSchema = yup.object().shape({
  title_ru: yup.string().required(requiredErrorMessage),
  content_ru: yup.string().required(requiredErrorMessage),
  title_kz: yup.string().required(requiredErrorMessage),
  content_kz: yup.string().required(requiredErrorMessage),
  title_kg: yup.string().required(requiredErrorMessage),
  content_kg: yup.string().required(requiredErrorMessage),
  title_uz: yup.string().required(requiredErrorMessage),
  content_uz: yup.string().required(requiredErrorMessage),
  notification_type: yup.string().required(requiredErrorMessage),
  app_types: yup.array().of(yup.string().required()).min(1, requiredErrorMessage).defined(),
  file: yup
    .mixed()
    .nullable()
    .test('is-xlsx', 'Файл может быть только в формате .xlsx, .xls или .csv', (value) => {
      if (value === null) {
        return true;
      }
      if (value instanceof File) {
        const fileExtension = value.name.split('.').pop()?.toLowerCase();
        return fileExtension === 'xlsx' || fileExtension === 'xls' || fileExtension === 'csv';
      }
      return false;
    }),
});

export const CreateDistributionCard = () => {
  const dispatch = useDispatch();

  const [createDistributionRequest] = useAddDistributionMutation();

  const defaultValues = useCreateDistributionCardDefaultValues();
  const [state, setState] = useState<DistributionStateType>({
    value: 0,
  });

  const { handleSubmit, ...form } = useForm({
    mode: 'all',
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const onSubmit = (data: DistributionFormDataType) => {
    createDistributionRequest({ body: data }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  return (
    <DistributionCard
      title="Новое уведомление"
      state={state}
      setState={setState}
      form={form}
      onSubmit={handleSubmit(onSubmit)}
      textButton="Создать"
    />
  );
};
